module.exports = __webpack_public_path__ + "img/2f_r_fukumitsu.6c2990a0.png";